export default __webpack_public_path__ + "media/zurb/img/ecommerce/shopping_flow1-38b7e83c9be42ac186d45492f086ecb6.png";